import {createRouter, createWebHistory} from 'vue-router'
import HomePage from '../views/HomePage.vue'
import ContactPage from '../views/ContactPage.vue'
import CareersPage from '../views/CareersPage.vue'
import ExpertisesPage from '../views/ExpertisesPage.vue'
import About from '@/views/About.vue'
import TeamPage from '@/views/TeamPage.vue'
import TeamDetail from '@/components/Team/TeamDetail.vue' // <--- IMPORT THE NEW COMPONENT
import PersonDetail from '@/components/Team/PersonDetail.vue'
import NewsPage from '../views/NewsPage.vue';
import ArticlePage from '../views/ArticlePage.vue';
import DataPrivacy from '../views/DataPrivacy.vue';
import TermsAndContion from '@/views/TermsAndContion.vue';
import CookiePolicy from '../views/CookiePolicy.vue';

const routes = [
  { 
    path: '/', 
    name: 'home', 
    component: HomePage,
    meta: {
      titleKey: 'pageTitles.home'
    }
  },
  { 
    path: '/about', 
    name: 'about', 
    component: About,
    meta: {
      titleKey: 'pageTitles.about'
    }
  },
  { 
    path: '/contact', 
    name: 'contact', 
    component: ContactPage,
    meta: {
      titleKey: 'pageTitles.contact'
    }
  },
  { 
    path: '/careers', 
    name: 'careers', 
    component: CareersPage,
    meta: {
      titleKey: 'pageTitles.careers'
    }
  },
  { 
    path: '/expertise', 
    name: 'expertise', 
    component: ExpertisesPage,
    meta: {
      titleKey: 'pageTitles.expertise'
    }
  },
  {
    path: '/dataprivacy', 
    name: 'DataPrivacy', 
    component: DataPrivacy,
    meta: {
      titleKey: 'pageTitles.dataPrivacy'
    }
  },
  {
    path: '/termscondition',
    name: 'TermsAndContion',
    component: TermsAndContion,
    meta: {
      titleKey: 'pageTitles.termsCondition'
    }
  },
  {
    path: '/cookiepolicy',
    name: 'CookiePolicy',
    component: CookiePolicy,
    meta: {
      titleKey: 'pageTitles.cookiePolicy'
    }
  },
  { 
    path: '/team', 
    name: 'team', 
    component: TeamPage,
    meta: {
      titleKey: 'pageTitles.team'
    }
  },
  {
    path: '/team/:id',
    name: 'TeamDetail',
    component: TeamDetail,
    props: true,
    meta: {
      titleKey: 'pageTitles.teamDetail'
    }
  },
  {
    path: '/team/associate/:id',
    name: 'PersonDetail',
    component: PersonDetail,
    props: true,
    meta: {
      titleKey: 'pageTitles.personDetail'
    }
  },
  {
    path: '/news',
    name: 'News',
    component: NewsPage,
    meta: {
      titleKey: 'pageTitles.news'
    }
  },
  {
    path: '/news/:id',
    name: 'ArticleDetail',
    component: ArticlePage,
    props: true,
    meta: {
      titleKey: 'pageTitles.articleDetail'
    }
  },
];

const router = createRouter({
  history: createWebHistory(), // En vables history mode (clean URLs)
  routes,
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition; // If there's a saved scroll position (e.g., browser back/forward), use it
    } else {
      return { top: 0, behavior: 'smooth' }; // Otherwise, scroll to the top of the page smoothly
    }
  }
});



export default router;